<template>
 <ul class="px-[10px]">
    <AccountCard
      v-for="value in filteredTransactions(accounts).items"
      :key="value.id"
      :account="value" />
    <div v-if="accounts.total > maxResults" class="flex justify-end mt-[5px]">
      <a
        @click="loadMoreResults"
        class="max-w-fit-content px-4 py-2 text-blue-dark font-jost-semibold text-right rounded-lg hover:bg-blue-700 transition-colors duration-200 block cursor-pointer">
        Show more
      </a>
    </div>
  </ul>
</template>

<script>
import { filteredTransactions } from '@/helpers/common';
import { MAX_SEARCH_RESULTS } from '@/helpers/constants';
import AccountCard from '@/components/common/AccountCard.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'AccountsList',
  components: {
    AccountCard,
  },
  props: {
    accounts: {
      type: Object,
      default: () => ({ items: [] })
    }
  },
  data() {
    return {
      uiTypes: UiTypes,
      maxResults: MAX_SEARCH_RESULTS,
    };
  },
  methods: {
    filteredTransactions(list) {
      return filteredTransactions(list);
    },
    loadMoreResults() {
      // Navigate to AllResults page with accounts type
      this.$router.push({
        name: 'resultsByType',
        params: { type: this.uiTypes.account },
        query: { value: this.$route.query.value}
      });
    }
  }
}
</script>
